module.exports = __webpack_public_path__ + "img/payroll-icon2.a4730bcc.svg";